export const mobileHeaderStyles = () => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      paddingLeft: 0,
      paddingRight: 0,
      width: '100%',
    },
    menuButton: {
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    menuIcon: {
      width: '30px',
      height: '30px',
    },
  };
};

